// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatSession|schemaHash=971c604854ee9c491a7c0b53a164732a67491596

import { checkDate } from '@myre/common-dates';
import { setDefinedValue } from '@myre/common-primitives';

export function parseChatSessionFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'creationDate', checkDate(_data.creationDate));
  setDefinedValue(result, 'updateDate', checkDate(_data.updateDate));
  setDefinedValue(result, 'id', _data.id);
  setDefinedValue(result, 'userId', _data.userId);
  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'title', _data.title);
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseChatSessionToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'creationDate', _data.creationDate instanceof Date ? _data.creationDate.toISOString() : _data.creationDate);
  setDefinedValue(result, 'updateDate', _data.updateDate instanceof Date ? _data.updateDate.toISOString() : _data.updateDate);
  setDefinedValue(result, 'id', _data.id);
  setDefinedValue(result, 'userId', _data.userId);
  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'title', _data.title);
  setDefinedValue(result, 'status', _data.status);

  return result;
}
